// src/components/ui/Tab.jsx
import React from 'react';

const Tab = ({ id, label, active, children }) => {
  if (!active) return null;
  
  return (
    <div className="py-4">
      {children}
    </div>
  );
};

// Set displayName for component identification by parent Tabs component
Tab.displayName = 'Tab';

export default Tab;